@if (showBackButton()) {
  <ui-icon-button buttonStyle="unthemed" icon="arrow-left" iconStyle="solid" (clicked)="goBack()"></ui-icon-button>
}

<ng-content select="ui-icon-button"></ng-content>

<div class="wrapper-content">
    <span class="headline" [class.with-subtitle]="!!subtitle()">
      <ng-content></ng-content>
    </span>

  @if (subtitle()) {
    <span class="subtitle">{{ subtitle() }}</span>
  }
</div>

@if (actionIcon(); as icon) {
  @if (actionLink(); as link) {
    <ui-button-link [link]="link" [matTooltip]="actionText()" buttonStyle="text" class="action">
      <ui-icon [faName]="icon" [faStyle]="actionIconStyle()"></ui-icon>
      <span class="action-text">{{ actionText() }}</span>
    </ui-button-link>
  } @else {
    <ui-button (clicked)="actionClicked.emit()" [tooltip]="actionText()" buttonStyle="text" class="action">
      <ui-icon [faName]="icon" [faStyle]="actionIconStyle()"></ui-icon>
      <span class="action-text">{{ actionText() }}</span>
    </ui-button>
  }

}

<ng-content select="[custom-action]"></ng-content>
